import { useAuthStore } from "~/store/auth/auth.store";
import { useSseStream } from "~/composables/realtime/useSseStream";
import { useAlertsStream } from "~/composables/alerts/useAlertsStream";
import { useCreateCompaniesStore } from "~/store/companies/create-company.store";
import { loadGoogleMaps, loadLuzmo, loadYoutube } from "~/utils/helpers/app-scripts";
import { isAuthDocumentUnloading } from "~/utils/helpers/auth/lifecycle";

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore();
  const companiesStore = useCreateCompaniesStore();
  const router = useRouter();
  const config = useRuntimeConfig();
  const { connect, disconnect } = useSseStream();
  const { start, stop } = useAlertsStream();
  let mounted = false;
  let activeSession: string | null = null;

  function stopBackgroundWork() {
    stop();
    disconnect();
    activeSession = null;
  }

  function startBackgroundWork() {
    const route = router.currentRoute.value;
    if (!mounted || isAuthDocumentUnloading()) return;
    if (!authStore.isLoggedIn() || !route.matched.length || route.meta.isLoggedIn === false) {
      stopBackgroundWork();
      return;
    }
    if (activeSession === authStore.sessionEpoch) return;
    activeSession = authStore.sessionEpoch;

    start();
    connect();
    const companyId = authStore.user?.mainEntityId?.companyId;
    if (companyId) void companiesStore.fetchOcrSignAndSheetSettings(companyId);
    void Promise.allSettled([loadGoogleMaps(config.public.GOOGLE_MAPS_API_KEY), loadYoutube(), loadLuzmo()]);
  }

  // Cover both a restored session on a direct URL and navigation out of the login funnel.
  nuxtApp.hook("app:mounted", () => {
    mounted = true;
    startBackgroundWork();
  });
  nuxtApp.hook("page:finish", startBackgroundWork);

  watch(
    () => [authStore.isLoggedIn(), authStore.sessionEpoch],
    () => {
      if (!authStore.isLoggedIn() || activeSession !== authStore.sessionEpoch) stopBackgroundWork();
      startBackgroundWork();
    },
    { flush: "post" },
  );
});
